import React from 'react'

import styles from './_landing.css'
import OwnEveryMile from './own-every-mile'
import Syncs from './syncs'
import Features from './features'
import Map from './map'

function Landing () {
  return (
    <div className={styles.page}>
      <OwnEveryMile />
      <Syncs />
      <div className={styles.topoWrapper}>
        <Features />
        <Map />
      </div>
    </div>
  )
}

export default Landing
